import styled from "styled-components";

export const LoadingScreen = styled.div`
  display: flex;
  margin-top: 3rem;
  align-items: center;
  justify-content: center;
`;

export const Spinner = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;

  &:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid ${(props) => props.theme.colors.accent1};
    border-color: ${(props) => props.theme.colors.accent1} transparent
      ${(props) => props.theme.colors.accent1} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
